import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Input from "../../_default/Input";
import "./Superset.scss";
import Exercise from "./Exercise";
import Icon from "../../_default/Icon";

export default function SupersetNoSearch({previousValues, setName, isPersonal, error, isAdmin, set, set_idx, removeSet, exercises, removeExercise, onClickSearch, onChange }) {
    console.log(set)
  return (
    <Draggable key={set.id} index={set_idx} draggableId={set.id}>
      {(provided, snapshot) => (
        <div className={`c-define-set ${snapshot.isDragging ? "--ondrag" : ""}`} isDragging={snapshot.isDragging} ref={provided.innerRef} {...provided.draggableProps}>
          <div className="c-set-title">
            <p>{set.name}</p>
            {isAdmin && (
              <div className="c-btn-collection">
                <div className="c-set-trash-icon" onClick={() => removeSet(set_idx)}>
                  <Icon icon="trash" size={16} />
                </div>
                <div className="c-set-move-icon" {...provided.dragHandleProps}>
                  <Icon icon="move" />
                </div>
              </div>
            )}
          </div>
          {/* <div className="c-set-item">
            {isAdmin ? (
              <Input placeholder="Full name of superset" label="Name" value={set.name} onChange={(e) => onChange(e, "name", false, set_idx)} error={error && error.type === "set_name" && error.idx === set_idx ? error.message : false} />
            ) : (
              <div className="c-no-admin-input-replace-no-bottom">
                <span>Name</span>
                <p>{set.name}</p>
              </div>
            )}
          </div> */}

          <Droppable droppableId={set.id} type="child">
            {(provided) => (
              <div className="c-set-exercises" ref={provided.innerRef} {...provided.droppableProps}>
                {set.exercises.map((item, idx) => (
                  <Exercise previousValues={previousValues} isPersonal={isPersonal} isAdmin={isAdmin} exercises={exercises} item={item} idx={idx} removeExercise={(idx) => removeExercise(idx, set_idx)} onChange={(e, type, exercise_idx) => onChange(e, type, exercise_idx, set_idx)} />
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
          {/*<div className="c-set-rest">
            {isAdmin ? (
              <>
                <p>Rest after set: </p>
                <input type="number" placeholder="0" value={set.rest_time_in_minutes} onChange={(e) => onChange(e.target.value, "rest_time_in_minutes", false, set_idx)} />
                <p>minutes</p>
              </>
            ) : (
              <p>Rest after set: {set.rest_time_in_minutes} minutes</p>
            )}
          </div>*/}
        </div>
      )}
    </Draggable>
  );
}
